import React, { useState } from "react";
import formatDate from "constants/formatDate";
import paymentTypeBadge from "constants/paymentTypeBadge";
import monthlyOrderStatusBadge from "constants/monthlyOrderStatusBadge";
import DeleteItemButton from "pages/MonthlyParking/DeleteItemButton";
import BarcodeCell from "pages/MonthlyParking/BarcodeCell";
import LongerTextTableCell from "pages/MonthlyParking/LongerTextTableCell";
import MonthlyParkingCustomerModal from "pages/MonthlyParking/MonthlyParkingCustomerModal";
import MonthlyParkingOrderUpdateModal from "pages/MonthlyParking/MonthlyParkingOrderUpdateModal";
import { updateMonthlyParkingPayment } from "helpers/fakebackend_helper";
import LineItemsCell from "./LineItemsCell";
import SubscriptionDetailsIcon from "./SubscriptionDetailsIcon";
import StripeTransactionIcon from "./StripeTransactionIcon";
import SendInvoiceIcon from "./SendInvoiceIcon";
import PayForOrderIcon from "./PayForOrderIcon";

export default function CreateOrderTableCells({
    o,
    filters,
    orders,
    openEditModal,
    reloadTime,
    showDelete = true,
    filterOrders,
    sortedOrders,
    setSortConfig
}) {
    const user = JSON.parse(localStorage.getItem("authUser"));
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [editModal, setEditModal] = useState(false);
    const [editOrder, setEditOrder] = useState(null);

    const handleOpenEditModal = (order) => {
        if (openEditModal) return openEditModal(order); // external control if provided
        setEditOrder(order);
        setEditModal(true);
    };

    const handleSaveEdit = async (data) => {
        if (!user?.token) return;

        const payload = { id: data.id };

        if (data.editType === "customer") {
            payload.customer_first_name = data.customer_first_name;
            payload.customer_last_name = data.customer_last_name;
            payload.customer_email = data.customer_email;
            payload.customer_phone = data.customer_phone;
            payload.customer_company_name = data.customer_company_name;
        } else {
            payload.status = data.status;
            payload.payment_type = data.payment_type;
            payload.date_created = data.order_date;
            if (data.payment_type === "cheque" && data.check_number) {
                payload.check_number = data.check_number;
            }
        }

        Object.keys(payload).forEach((k) => {
            if (payload[k] === "" || payload[k] == null) delete payload[k];
        });

        await updateMonthlyParkingPayment(user.token, data.id, payload);
        setEditModal(false);
        reloadTime()
    };

    return (
        <>
            <td
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => handleOpenEditModal({ ...o, editType: "order-date" })}
            >{formatDate(o.date_created)}</td>
            <LongerTextTableCell
                value={
                    o.customer_first_name + " " + o.customer_last_name +
                    ((o.customer_company_name &&
                        o.customer_company_name !== "null" &&
                        o.customer_company_name !== "")
                        ? " - " + o.customer_company_name
                        : "")
                }
                maxLength={75}
                onClick={() => setSelectedCustomer(o)}
            />
            <LineItemsCell
                line_items_json={o.line_items_json}
                quantity={o.quantity}
                item_type={o.item_type}
            />
            <td>{paymentTypeBadge(o.payment_type, o.check_number)}</td>
            <td
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={() => handleOpenEditModal({ ...o, editType: "status_payment" })}
            >
                {monthlyOrderStatusBadge(o.status)}
            </td>
            <td>${o.total}</td>
            <BarcodeCell barcode={o.barcode_number} show={filters.showBarcode} />
            {showDelete && (
                <td>
                    <DeleteItemButton
                        id={o.id}
                        token={user?.token}
                        reloadTime={reloadTime}
                        itemLabel="order"
                    />
                    <SubscriptionDetailsIcon
                        email={o.customer_email}
                        user={user}
                        orders={orders}
                        filters={filters}
                        filterOrders={filterOrders}
                        sortedOrders={sortedOrders}
                        setSortConfig={setSortConfig}
                        onRefresh={reloadTime}
                    />
                    <SendInvoiceIcon orderId={o.order_id} />
                    {o.status != "completed" && <PayForOrderIcon orderId={o.order_id} />}
                    <StripeTransactionIcon transactionId={o.transaction_id} />
                </td>
            )}

            {/* Embedded Modals */}
            <MonthlyParkingCustomerModal
                customer={selectedCustomer}
                onClose={() => setSelectedCustomer(null)}
                onEdit={(data) => {
                    setSelectedCustomer(null);
                    handleSaveEdit(data);
                }}
            />

            <MonthlyParkingOrderUpdateModal
                isOpen={editModal}
                toggle={() => setEditModal(false)}
                order={editOrder}
                onSave={handleSaveEdit}
            />
        </>
    );
}